import { createSlice } from '@reduxjs/toolkit';

export const surveySlice = createSlice({
  name: 'survey',
  initialState: {
    check_survey: false,
    process: 'LOGIN',
    course_id: null
  },
  reducers: {
    updateSurvey: (state, action) => {
      state.check_survey = action.payload.check_survey;
      state.process = action.payload.process;
      state.course_id = action.payload.course_id ?? null;
    }
  }
});

export const {
  updateSurvey
} = surveySlice.actions;

export default surveySlice.reducer;